import React from 'react';
import Button from '@sizeid/commons/components/Button';
import { Icon } from '@sizeid/commons/components/SvgImage';
import { SIGN_INDEX } from '@sizeid/shared/constants/routes';

import RouteLink from 'components/RouteLink';
import { useTranslation } from 'lib/i18n';

import BackToSignContainer from './styled/BackToSignContainer';
import { BackToSignProps } from './types';

const BackToSign: React.FC<BackToSignProps> = props => {
  const { t } = useTranslation('pages');
  return (
    <BackToSignContainer>
      <RouteLink
        href={{
          pathname: SIGN_INDEX.route,
          query: props.advisor ? { advisor: true } : undefined,
        }}
        passHref
      >
        {/* eslint-disable-next-line jsx-a11y/anchor-is-valid*/}
        <a>
          <Button outline secondary>
            <Icon image="arrow" />
            {t('forgottenPassword.backToSign')}
          </Button>
        </a>
      </RouteLink>
    </BackToSignContainer>
  );
};

export default BackToSign;
